module.exports = __webpack_public_path__ + "img/.pdf.ff1d6a3e.png";